import React from 'react';
import { GraduationCap, TrendingUp, Award } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { diantosanProgram, contactInfo } from '../utils/mockData';

export const DiantosanSection = () => {
  const handleWhatsApp = () => {
    const message = 'Halo, saya ingin mengetahui lebih lanjut tentang Program Diantosan.';
    const url = `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section id="diantosan" className="py-20 bg-gray-50 dark:bg-[#121212] scroll-mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <img
              src={diantosanProgram.image}
              alt="Diantosan Program"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
          </div>
          <div className="space-y-6 order-1 lg:order-2">
            <Badge className="bg-[#D32F2F] text-white hover:bg-[#B71C1C] px-4 py-1">
              Program Unggulan
            </Badge>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white">
              {diantosanProgram.title}
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
              {diantosanProgram.description}
            </p>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <GraduationCap className="w-6 h-6 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <span className="text-gray-700 dark:text-gray-300">Fokus pemberdayaan pesantren dan komunitas</span>
              </div>
              <div className="flex items-start space-x-3">
                <TrendingUp className="w-6 h-6 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <span className="text-gray-700 dark:text-gray-300">Akselerasi pertumbuhan UMKM lokal</span>
              </div>
              <div className="flex items-start space-x-3">
                <Award className="w-6 h-6 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <span className="text-gray-700 dark:text-gray-300">Program edukasi digital yang komprehensif</span>
              </div>
            </div>
            <Button
              onClick={handleWhatsApp}
              className="bg-[#D32F2F] hover:bg-[#B71C1C] text-white px-8 py-6 text-lg"
            >
              Ajukan Kerja Sama Program
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
